import { render, staticRenderFns } from "./ChipDetailCard.vue?vue&type=template&id=2c2399eb&"
import script from "./ChipDetailCard.vue?vue&type=script&lang=js&"
export * from "./ChipDetailCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports